exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".app-select-modal {\n  margin: 10px auto 15px auto; }\n  .app-select-modal .MuiFormControl-root {\n    width: 100%; }\n", ""]);

